export default __webpack_public_path__ + "static/media/6.08d4303d.jpg";